"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What is a Timber Composition Analysis (TCA)?",
  answer: "A Timber Composition Analysis (TCA) gives you a clear, property-wide view of your timber—how many trees you have, how they're structured, and how your land is laid out. Most landowners don't have this baseline. As a result, they end up guessing—selling too early, waiting too long, or making decisions that can impact the long-term value of their land. A TCA is designed to prevent that. It gives you an objective starting point so you can understand what you have before you commit time, money, or access to your property—and before you make a decision you can't undo."
}, {
  question: "How is this different from working with a forester?",
  answer: "A TCA is not a replacement for a forester—it’s a complementary first step. We help you understand what you have so you can have a more informed conversation when you engage a forester for a field-based timber cruise or management plan. Our role is to provide clarity early. A forester’s role is to provide on-the-ground expertise, validation, and execution."
}, {
  question: "When should I use a TCA—and when should I call a forester?",
  answer: "A TCA is most useful before you make a decision. If you’re unsure what’s on your land, whether your timber matters, or what direction to take, this gives you a clear starting point. Once you’re ready to move forward—whether that’s harvesting, management, or valuation—a licensed forester should be brought in to guide that next step."
}, {
  question: "What can I actually use a TCA for?",
  answer: "Landowners typically use a TCA to:<br/><ul class='list-disc ml-5 space-y-1'><li>Understand what they have before making a decision</li><li>Avoid selling too early or waiting too long</li><li>Get clarity before buying, selling, or managing land</li><li>Have a more productive conversation with a forester</li></ul>"
}, {
  question: "How long does it take and what does it cost?",
  answer: "Most TCAs are delivered within a few days once we begin. Our standard pricing is $499 for properties up to 200 acres (single parcel). Larger or more complex properties may require a custom quote."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="247474" id="frequently-asked-questions" className="bg-background text-foreground py-16 md:py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] bg-[linear-gradient(to_bottom,transparent_50%,#000_50%)] bg-[length:100%_4px]" />

      <div ref={ref} className={`container mx-auto px-4 max-w-3xl transition-all duration-700 ease-out relative z-10 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-default font-extrabold text-foreground mb-4 tracking-tighter">Frequently Asked Questions About Your Timber</h2>
          
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b-[0.5px] border-border bg-card/5 backdrop-blur-sm last:border-b-0">
              <AccordionTrigger className="text-foreground font-default font-semibold text-lg hover:no-underline hover:bg-accent/5 py-6 text-left transition-all group">
                <span className="flex items-center gap-4">
                  <span className="font-mono text-chart-2 text-sm">
                    [{String(i + 1).padStart(2, "0")}]
                  </span>
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-sans leading-relaxed text-base pb-6 px-4 md:px-8 animate-in slide-in-from-left-2 duration-500">
                <div dangerouslySetInnerHTML={{
              __html: faq.answer
            }} />
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}